import { toast } from 'react-toastify';
import { apiClient } from './client';
import { extractItemsFromResponse, extractPagedItemsAndTotal, handleApiError } from './utils';

export const fetchAnnouncementById = async ({ apiEndpoint, id }) => {
    if (!id) {
        toast.error('Duyuru getirmek için ID gereklidir.');
        return null;
    }
    try {
        const response = await apiClient.get(`${apiEndpoint}/${id}`);

        if (response.data && response.status === 200) {
            const responseData = extractItemsFromResponse(response.data);
            const normalizedData = Array.isArray(responseData) ? responseData[0] : responseData;

            if (!normalizedData || normalizedData.id === undefined) {
                toast.error(`Duyuru verisi alınırken beklenmeyen yapı (ID: ${id}).`);
                return null;
            }

            return {
                id: normalizedData.id,
                title: normalizedData.title,
                desc: normalizedData.text || normalizedData.desc,
                isActive: normalizedData.isActive,
                created: normalizedData.created
            };
        } else {
            toast.error(`Duyuru alınırken beklenmeyen bir yanıt alındı (ID: ${id}, Status: ${response.status}).`);
            return null;
        }
    } catch (error) {
        handleApiError(error, 'Duyuru alınırken bir hata oluştu.');
        return null;
    }
};

export const fetchAllAnnouncements = async ({
    apiEndpoint,
    params = {}
}) => {
    const requestParams = {
        count: params.count || 10,
        ...params
    };

    try {
        const response = await apiClient.get(apiEndpoint, { params: requestParams });

        let items = [];
        const { rawItems, total } = extractPagedItemsAndTotal(response.data);

        if (Array.isArray(rawItems)) {
            items = rawItems.map(item => {
                if (item && item.id !== undefined) {
                    return {
                        id: item.id,
                        title: item.title || 'Başlıksız Duyuru',
                        desc: item.text || item.desc || '',
                        isActive: item.isActive === true,
                        created: item.created
                    };
                } else {
                    return null;
                }
            }).filter(item => item !== null);
        }

        return { items, total };

    } catch (error) {
        handleApiError(error, 'Duyurular alınırken bir hata oluştu.');
        return { items: [], total: 0 };
    }
};
